import { Unit } from '@adUtilities/types/apartment'
import { PropertyType } from '@adUtilities/types/common'
import { Lot } from '@adUtilities/types/houseAndLand'

export interface UnitProperty {
  propertyType: PropertyType.Unit
  data: Unit
  references: {
    levelId: string
  }
}

export interface LotProperty {
  propertyType: PropertyType.Lot
  data: Lot
  references: {
    precinctId: string
    stageId: string
  }
}

export interface ComparableProperty {
  index: number
  property: UnitProperty | LotProperty | null
}

export interface RequiredComparableProperty extends Omit<
  ComparableProperty,
  'property'
> {
  property: NonNullable<ComparableProperty['property']>
}

export enum PropertyPositionInCompareMode {
  First = 'first',
  Last = 'last',
}
